import React, { useState } from "react";
import axiosWithHandling from "../backend/axiosHanding";
import { apiURL } from "../backend/ApiURLs";
import "../design/resetPassword.css"

export default function InputUserCredentials() {

    const [email, setEmail] = useState("");
    const [errorMessage, setErrorMessage] = useState(null); 
    const [successMessage, setSuccessMessage] = useState(null); 
    const [isSubmitting, setIsSubmitting] = useState(false);   

    const url = `${apiURL}resetCredentials/createResetPasswordTokenAndSendEmail?emailOrUsername=${encodeURIComponent(email)}`

    const handleSubmit = () => {
        setIsSubmitting(true)

        const isValidEmail = validateEmailInput(email)

        if (isValidEmail != "") {
            setIsSubmitting(false)
            setErrorMessage(isValidEmail)
            return
        }
        

        axiosWithHandling(url, {method : "POST"})
        .then(data => {
            setIsSubmitting(false)
            setSuccessMessage("Email sent! Make sure to check your spam folder.")
        })
        .catch(error => {
            setIsSubmitting(false)
            var statusCode = error.message

            setErrorMessage(validateResponseFromServer(statusCode))
        })
    }

    const validateResponseFromServer = (statusCode) => {
        if (statusCode == 404) {
            return "User with email address not found"
        }
    
        if (statusCode == 429) {
            return "Too many emails have been this to email, please try again later"
        }

        return `Unkown error: ${statusCode}`
    }

    const validateEmailInput = (emailInput) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        if (!emailInput) {
            return "Email is required.";
        }
    
        if (!emailRegex.test(emailInput)) {
            return "Please enter a valid email address.";
        }
    
        return "";
    };
    
        
    return(
        <div>
            <h1 className="header">Reset Your Password</h1>

            <div className="resetPasswordBackground"> 
            
            <h3 className="resetPasswordSuccessMessage">
                Enter the email associated with your account.
                We'll send you a verification email to confirm your identity.
            </h3>

            <label>
                Email
                <input type="email" onChange={(e) => setEmail(e.target.value)}>
                </input>
            </label>

            <div className="errorMessage">
                {errorMessage}
            </div>

            <div className="resetPasswordSuccessMessage">
                {successMessage}
            </div>

            <button className="submitButton" disabled={isSubmitting} onClick={handleSubmit}>
                {isSubmitting ? "Sending" : "Send Email"}
            </button>

        </div>
        </div>
    )

};